/**
 * Classe de grid paa a funcionalidade de monitoring orders.
 * @author: adalto.junior
 * Date: 19/10/13
 * Time: 15:14
 */


Greenmile.RouteSummary = Greenmile.RouteSummary || {};
Greenmile.RouteSummary.Orders = Greenmile.RouteSummary.Orders || {};
Greenmile.RouteSummary.Orders.Grid = (function () {

    function Grid () {

        Greenmile.RouteSummary.Grid.apply(this, arguments);

        this.entity = 'RouteSummaryOrders';
        this.entityToActionGrid = 'Order';
        this.countCustomColumns = 0;

        this.containerGrid = "#RouteSummary #ordersGrid #grid";
        this.gridActionsSelector = "#RouteSummary #allContent #ordersGrid .gridActions";

        this.afterShow = function () {

            if (!App.Forms.StopView) {
                App.Forms.StopView = {};
            }
            App.Forms.StopView.filterBuilder = App.Forms.Order.filterBuilder;
            App.Forms.StopView.invalidated = true;
            App.Forms.StopView.filterBuilder.postRender();

            this.exportFormats.maxResult = 100000;
            this.exportFormats.setEntityToRequest("StopView");
            var oldGetFieldsSelecteds = this.exportFormats.getFieldsSelecteds;
            this.exportFormats.getFieldsSelecteds = function () {
                var fieldsSelecteds = oldGetFieldsSelecteds.call(this);
                var collection = [];
                collection.push('"id"');
                fieldsSelecteds.forEach(function (field) {
                    var key = field.split(".")[0].replace(/\"/g, "");
                    if (key !== "stop" && key !== "routeView") {
                        field = 'stop.orders.' + field;
                    }
                    field = field.replace(/\"/g, "");
                    collection.push('"' + field + '"');
                });
                return collection;
            }.bind(this.exportFormats);

        };

    }

    return Grid;

}());